"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [{
  url: '/cats/create',
  type: 'post',
  response: function response(config) {
    return {
      code: 20000,
      message: 'success!' // data: {
      //   total: items.length,
      //   items: items
      // }
      // mock error

    };

    if (!token) {
      return {
        code: 60204,
        message: 'Account and password are incorrect.'
      };
    }

    return {
      code: 20000,
      data: token
    };
  }
}];
exports.default = _default;